<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor" v-if="chipColor">
    {{value}}
  </vs-chip>
  <span v-else>-</span>
</template>

<script>
export default {
  name: 'CellRendererRepeat',
  computed: {
    chipColor () {
      let data = this.params.data;
      let hasRepeat = [data.repeat_years, data.repeat_months, data.repeat_days].some(item => item > 0);
      return hasRepeat ? 'primary' : false;
    },
    value () {
      let result = "", data = this.params.data;
      if (data.repeat_years > 0)
        result += data.repeat_years + ' years';
      else if (data.repeat_months > 0)
        result += data.repeat_months + ' months';
      else if (data.repeat_days > 0)
        result += data.repeat_days + ' days';

      return result;
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-primary {
    background: rgba(var(--vs-primary),.15);
    color: rgba(var(--vs-primary),1) !important;
    font-weight: 500;
  }
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
